<template>
    <router-link
        v-bind="$attrs"
        active-class="active | w-19 text-white rounded-r | 2xl:w-61"
        class="
            nio-button nio-button-blue
            w-18 z-10 flex items-center justify-center px-6 py-4 bg-white
            2xl:w-60 2xl:justify-start
        "
        :to="to"
        v-tooltip="{ content: tooltipContent, placement: 'right' }"
    >
        <nio-icon class="text-xl" :name="icon" />
        <span class="ml-3 text-base hidden | 2xl:block" v-text="title" />
        <div
            class="
                inline-flex items-center justify-center absolute top-0 right-0 h-4 min-w-4 mr-2 mt-2 p-1 rounded-full bg-red-500 text-white text-xs
                2xl:relative 2xl:mr-0 2xl:mt-0 2xl:ml-2
            "
            v-text="badge"
            v-if="badge"
        />
    </router-link>
</template>

<script>
    export default {
        props: {
            to: {
                type: [Object, String],
                required: true,
            },
            icon: {
                type: String,
                required: true,
            },
            badge: {
                type: [String, Number],
                default: '',
            },
            title: {
                type: String,
                required: true,
            },
        },

        computed: {
            tooltipContent() {
                return this.$mq === '2xl' ? '' : this.title;
            },
        },
    };
</script>
